module.exports = __webpack_public_path__ + "static/media/contestacoes-vistorias.16902285.svg";